
    import * as React from 'react';

    const Zoom32 = ({ color = 'currentcolor', height = '32px', width = '32px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 32 32" style={svgStyle}><g><path d="M16 31c8.285 0 15-6.717 15-15 0-8.283-6.715-15-15-15S1 7.717 1 16c0 8.283 6.715 15 15 15zm0-1C8.268 30 2 23.731 2 16S8.268 2 16 2s14 6.269 14 14-6.268 14-14 14z" /><path d="M16.5 15.5h7v1h-7v7h-1v-7h-7v-1h7v-7h1v7z" /></g></svg>
        </div>
      );
    };

    Zoom32.displayName = 'Zoom32';

    export default Zoom32;
  